import {AbstractEditParameterComponent} from "../AbstractEditParameterComponent";

export class EditEquity extends AbstractEditParameterComponent {

    static instance = () => Object.assign(AbstractEditParameterComponent.instance(), {
        template: require('./editEquity.html'),
        controller: AbstractEditParameterComponent.controllerInstance.concat([EditEquity]),
    });

}